import { mapState, mapMutations } from 'vuex';
import { validationFormMixin } from '../../../../modules/shared/mixins/validationFormMixin';
import {
  fetchSatCodeBy,
  createSATCode,
  updateSATCode,
  deleteSATCode,
} from '../../helpers/KnProductsOption';
import KnFormSubtitle from '../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import KnTextField from '../../../shared/components/KnTextField.vue';
import KnPagination from '../../../shared/components/KnPagination.vue';
import { paginationMixin } from '@/modules/shared/mixins/paginationMixin';

export default {
  components: {
    KnFormSubtitle,
    KnFormActionButtons,
    KnTextField,
    KnPagination,
  },
  mixins: [paginationMixin, validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      satCode: {
        id: 'NA', // No asignado
        dato: null,
        descripcion: null,
        id_autor: null,
        id_institucion_educativa: null,
      },
      satCodes: [],
      toUpdate: false,
      imageFile: null,
      showInactive: false,
      loading: false,
    };
  },
  async created() {
    this.setIsLogin(false);
    await this.getPaginatedSatCodeBy(1);
    this.satCode.id_autor = this.userData.id;
    this.satCode.id_institucion_educativa = this.institutionId;
    //this.satCodes = await fetchSatCodeByEI(this.institutionId); //this.fetchResultsByEI('productos', 'codigos-sat', this.institutionId)
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear';
    },
    invalidFields() {
      return this.objectHasNulls(this.satCode);
    },
  },
  watch: {
    showInactive: {
      async handler() {
        await this.getPaginatedSatCodeBy(1);
      },
    },
    institutionId: {
      async handler() {
        this.setIsLogin(false);
        await this.getPaginatedSatCodeBy(1);
        this.satCode.id_autor = this.userData.id;
        this.satCode.id_institucion_educativa = this.institutionId;
      },
    },
  },
  methods: {
    ...mapMutations(['setIsLogin']),
    async getPaginatedSatCodeBy(page = 1) {
      try {
        this.satCodes = [];
        this.setPaginationPage(page);

        if (!this.loading) {
          this.loading = true;

          const { ok, data, message, count } = await fetchSatCodeBy({
            institutionId: this.institutionId,
            systemStatus: !this.showInactive,
            limit: this.pagination.limit,
            offset: this.pagination.offset,
          });

          if (ok) {
            this.setPaginationCount(count);
            for (const satCode of data) {
              this.satCodes.push({ ...satCode });
            }
          } else {
            console.error('No se pudieron obtener los codigos', message);
          }

          this.loading = false;
        }
      } catch (error) {
        console.error('Error al obtener los codigos:', error);
        this.loading = false;
      }
    },
    async save() {
      if (this.toUpdate) {
        await updateSATCode(
          this.satCode.id,
          this.satCode.dato,
          this.satCode.descripcion,
          this.satCode.id_institucion_educativa,
          this.satCode.id_autor
        );
        this.toUpdate = false;
        await this.getPaginatedSatCodeBy(1);
      } else {
        await createSATCode(
          this.satCode.dato,
          this.satCode.descripcion,
          this.satCode.id_institucion_educativa,
          this.satCode.id_autor
        );
        this.clear();
        await this.getPaginatedSatCodeBy(1);
      }
      this.clear();
    },
    clear() {
      this.satCode = {
        id: 'NA', // No asignado
        dato: null,
        descripcion: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    clearInline() {
      this.satCode = {
        id: 'NA', // No asignado
        dato: null,
        descripcion: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    edit(item) {
      this.satCode = { ...item };
      this.satCode.id_institucion_educativa = item.institucion_educativa.id;
      this.toUpdate = true;
    },
    async deleteInline(itemId) {
      await deleteSATCode(itemId);
      await this.getPaginatedSatCodeBy(1);
      this.clearInline();
    },
  },
};
